interface SpinnerProps {
  className?: string;
  size?: 'sm' | 'lg';
}

const spinnerStyles =
  'animate-spin m-auto rounded-full border-grey40 border-t-primary';

const Spinner = ({ className, size = 'lg' }: SpinnerProps) => (
  <div
    className={`${spinnerStyles} ${className || ''} ${
      size === 'sm' ? 'size-4 border-2' : 'size-12 border-4'
    }`}
  />
);

export default Spinner;
